<template>
    <div class="modal-content consents-modal">
        <div class="modal-header bg-1 text-center">
            <modal-close />

            <div class="modal-title">
                <h2 class="h3 pt-2 pb-1 mb-0">Świetnie!</h2>
            </div>
        </div>
        <div class="modal-body p-4 text-primary consents-modal__body">
            <h3 class="h4 text-center typo--normal mb-4 mt-1">
                Zmodyfikowano promocję: <br />
                <strong>{{ accepted.promos[0].name }}</strong>
            </h3>

            <!-- Labels -->
            <disabled-labels-warning
                v-if="accepted.promos"
                :accepted-promos="accepted.promos"
            />

            <the-btn
                btn-class="btn-download-labels btn-block btn-primary mb-3"
                text="Generuj wybrane cenówki"
                icon="PriceTags"
                :disabled="isDownloadLabelsBtnDisabled"
                @click.native="downloadLabels"
            >
                <button-spinner class="ml-3" :status="downloadLabelsStatus" />
            </the-btn>

            <div
                v-if="$store.getters.isMerchantDiagnosticInvalid(acceptedLocId)"
                class="text-sm a-infoBar a-infoBar--error mb-3"
            >
                Uwaga! Przynajmniej jedno urządzenie fiskalne ma problem z
                połączeniem z serwerem.
            </div>

            <div class="text-sm a-infoBar a-infoBar--warning">
                Zmiana ceny / kodu trafi na stanowiska sprzedażowe w przeciągu
                maksymalnie 15 minut.
            </div>

            <div
                v-if="isShopApi"
                class="text-sm a-infoBar a-infoBar--warning mt-3"
            >
                Zmodyfikowaną promocję należy ponownie eksportować do systemu
                zapleczowego
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer" style="position: sticky; bottom: 0">
            <the-btn
                class="ml-auto"
                text="Zamknij"
                @click.native="$store.dispatch('toggleModal', false)"
            />
        </div>
    </div>
</template>

<script>
import { wtAccepted } from '@/walkthroughs/wtData'
import DisabledLabelsWarning from '@/components/labels/DisabledLabelsWarning.vue'

export default {
    components: {
        DisabledLabelsWarning
    },
    computed: {
        accepted() {
            return this.$store.getters.getProcessedSubscriptionByType(
                'accepted'
            )
        },

        acceptedMerchantId() {
            if (!this.accepted) {
                return null
            }
            return this.accepted.promos[0].merchant_id
        },

        acceptedLocId() {
            if (!this.accepted) {
                return null
            }
            return this.$store.getters.getMerchantById(this.acceptedMerchantId)
                .location_id
        },

        errors() {
            return this.$store.getters.getProcessedSubscriptionByType('error')
        },

        downloadLabelsStatus() {
            return this.$store.getters.getGeneratedLabelsStatus
        },

        isDownloadLabelsBtnDisabled() {
            if (!this.accepted.pagination?.totalRecords > 0) {
                // if there are no promos activated
                return true
            }

            const enabledTypes = this.$store.getters.getLabelPromoTypes

            // if every activated promo is disabled for labels
            return this.accepted.promos?.every((promo) =>
                !enabledTypes.includes(promo.type)
            )
        },

        userServices() {
            return this.$store.getters.getServices
        },

        isShopApi() {
            return !!this.userServices.findIndex(service => service.code === 'shop_api')
        },

        isWalkThroughActive() {
            return this.$store.getters.getWalkthroughActive
        }
    },
    methods: {
        async downloadLabels() {
            try {
                let accepted = {}

                if (this.$store.getters.getWalkthroughActive) {
                    accepted = { promos: wtAccepted }
                } else {
                    this.$store.dispatch('setGeneratedLabelsStatus', 'loading')
                    const processedResponse = await this.$store.dispatch(
                        'getAllProcessedSubsData'
                    )
                    if (processedResponse && processedResponse.data.data) {
                        accepted = processedResponse.data.data.accepted
                    }
                }

                const groups = []

                accepted.promos.forEach((promo) => {
                    const group = groups.find(group => group.id === promo.group_id)

                    if (!group) {
                        groups.push({
                            id: promo.group_id,
                            selectedPromoIds: [promo.id]
                        })
                    } else {
                        group.selectedPromoIds.push(promo.id)
                    }
                })
                if (!this.isWalkThroughActive) {
                    await this.$store.dispatch('clearFilters', 'labelGroups')
                }
                this.$store.dispatch('clearLabelGroups', false)
                this.$store.dispatch('unselectAllLabelGroupLabels')
                if (!groups.length) {
                    return this.$store.dispatch(
                        'setGeneratedLabelsStatus',
                        'idle'
                    )
                }

                await this.$store.dispatch('loadSelectedLabelGroups', {
                    groups
                })

                await this.$store.dispatch('toggleModal', false)
                this.$store.dispatch('openModal', {
                    component: 'ModalLabels',
                    classes: 'm-labels'
                })
            } catch (e) {
                console.error(e)
            } finally {
                this.$store.dispatch('setGeneratedLabelsStatus', 'idle')
            }
        }
    },

    created() {
        this.$store.dispatch('servicesFetch')
    }
}
</script>
